import { Grid, Typography, Box, Stack } from '@mui/material';
import { ENVIRONMENT } from 'config';

const chunk = (arr, size = 2) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) {
      acc.push({
        id: `set-${acc.length + 1}`,
        items: arr.slice(i, i + size),
      });
    }
    return acc;
  }, []);

const TabularFilterHeader = ({
  title,
  hotelName,
  isHotelSet = false,
  comparisonHotelName,
  isComparisonHotelSet = true,
  sections,
  chunkSize = 2,
  interpreterFragment = null,
}) => {
  const pairedSections = chunk(sections, chunkSize);
  return (
    <Box py={1} width="100%" mb={1} mr={4}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography fontWeight={600}> {title}</Typography>
        {ENVIRONMENT.IS_VISUAL_INTERPRETER_ENABLED?.toLowerCase() === 'true' && (
          <Grid item mt={1} mr={4}>
            {interpreterFragment}
          </Grid>
        )}
      </Stack>
      <Typography fontWeight="bold" mt={1}>
        {comparisonHotelName ? (
          <>
            Selection Hotel{isHotelSet ? ' Set' : ''} (A):{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>{' '}
            <br />
            Comparison Hotel{isComparisonHotelSet ? ' Set' : ''} (B):{' '}
            <Box component="span" fontWeight="bold">
              {comparisonHotelName}
            </Box>
          </>
        ) : (
          <>
            Hotel{isHotelSet ? ' Set' : ''} :{' '}
            <Box component="span" fontWeight="bold">
              {hotelName}
            </Box>
          </>
        )}
      </Typography>
      {chunkSize === 1 ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            flexDirection: 'row',
          }}
        >
          {pairedSections.map((set) =>
            set.items.map((section) => (
              <Typography
                fontSize={11}
                fontFamily="'Segoe UI', wf_segoe-ui_bold, helvetica, arial, sans-serif"
                key={section.id}
                mt={2}
              >
                {section.title}: {section.value}
              </Typography>
            ))
          )}
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            width: '100%',
            columnGap: 2,
            mt: 1,
          }}
        >
          {pairedSections.map((set) => (
            <Box key={set.id} sx={{ flexBasis: { xs: '100%', sm: 'auto' } }}>
              {set.items.map((section) => (
                <Typography
                  fontFamily="'Segoe UI', wf_segoe-ui_bold, helvetica, arial, sans-serif"
                  key={section.id}
                  mt={2}
                  sx={{ fontSize: { xs: 8, sm: 9, md: 9.8, lg: 10.5, xl: 11 } }}
                >
                  {section.title}: {section.value}
                </Typography>
              ))}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default TabularFilterHeader;
